// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Global ─────────────────────────────────────────── */
.App {
    min-height: 100vh;
}

/* ─── Login page background ──────────────────────────── */
.login-bg {
    background: radial-gradient(ellipse at top left,  #2e1065 0%, #1e1b4b 40%, #0f0a28 100%);
    position: relative;
    overflow: hidden;
}
.login-bg::before {
    content: '';
    position: absolute;
    width: 600px; height: 600px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(139,92,246,0.15) 0%, transparent 70%);
    top: -200px; left: -200px;
    pointer-events: none;
}
.login-bg::after {
    content: '';
    position: absolute;
    width: 400px; height: 400px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(109,40,217,0.12) 0%, transparent 70%);
    bottom: -100px; right: -100px;
    pointer-events: none;
}

/* ─── Data table ─────────────────────────────────────── */
.data-table th {
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
    background-color: rgb(248 250 252 / 0.8);
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: left;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    --tw-text-opacity: 1;
    color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.data-table td {
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(248 250 252 / var(--tw-border-opacity, 1));
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    --tw-text-opacity: 1;
    color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.data-table tbody tr {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    animation-duration: 150ms;
}
.data-table tbody tr:hover {
    background-color: rgb(250 245 255 / 0.4);
}

/* ─── Form elements ──────────────────────────────────── */
.form-label {
    margin-bottom: 0.375rem;
    display: block;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.form-input {
    width: 100%;
    border-radius: 0.75rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding-left: 0.875rem;
    padding-right: 0.875rem;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    outline: 2px solid transparent;
    outline-offset: 2px;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 200ms;
    animation-duration: 200ms;
}
.form-input::placeholder {
    --tw-text-opacity: 1;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.form-input:focus {
    --tw-border-opacity: 1;
    border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(192 132 252 / var(--tw-ring-opacity, 1));
}
.form-select {
    width: 100%;
    border-radius: 0.75rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding-left: 0.875rem;
    padding-right: 0.875rem;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    outline: 2px solid transparent;
    outline-offset: 2px;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 200ms;
    animation-duration: 200ms;
}
.form-select:focus {
    --tw-border-opacity: 1;
    border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(192 132 252 / var(--tw-ring-opacity, 1));
}
.form-input:hover, .form-select:hover {
    border-color: #c4b5fd;
}

/* ─── Buttons ────────────────────────────────────────── */
.btn-primary {
    border-radius: 0.75rem;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 200ms;
    animation-duration: 200ms;
}
.btn-primary:hover {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn-primary:active {
    --tw-scale-x: .95;
    --tw-scale-y: .95;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.btn-primary {
    background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
}
.btn-primary:hover {
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    transform: translateY(-1px);
}
.btn-secondary {
    border-radius: 0.75rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(109 40 217 / var(--tw-text-opacity, 1));
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 200ms;
    animation-duration: 200ms;
}
.btn-secondary:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.btn-outline {
    border-radius: 0.75rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(51 65 85 / var(--tw-text-opacity, 1));
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 200ms;
    animation-duration: 200ms;
}
.btn-outline:hover {
    --tw-border-opacity: 1;
    border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.btn-danger {
    border-radius: 0.75rem;
    --tw-bg-opacity: 1;
    background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 200ms;
    animation-duration: 200ms;
}
.btn-danger:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1));
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn-danger:active {
    --tw-scale-x: .95;
    --tw-scale-y: .95;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

/* ─── Page layout ────────────────────────────────────── */
.page-header {
    margin-bottom: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
@media (min-width: 768px) {
    .page-header {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}
.page-title {
    font-family: Manrope, sans-serif;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 700;
    --tw-text-opacity: 1;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
@media (min-width: 768px) {
    .page-title {
        font-size: 1.875rem;
        line-height: 2.25rem;
    }
}

/* ─── Empty state ────────────────────────────────────── */
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 5rem;
    padding-bottom: 5rem;
    --tw-text-opacity: 1;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

/* ─── Search input ───────────────────────────────────── */
.search-input {
    width: 100%;
    border-radius: 0.75rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    padding-left: 2.5rem;
    padding-right: 1rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    outline: 2px solid transparent;
    outline-offset: 2px;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.search-input:focus {
    --tw-border-opacity: 1;
    border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(192 132 252 / var(--tw-ring-opacity, 1));
}
@media (min-width: 768px) {
    .search-input {
        width: 18rem;
    }
}
.search-input:hover {
    border-color: #c4b5fd;
}

/* ─── Dropdown ───────────────────────────────────────── */
.dropdown-content {
    min-width: 10rem;
    border-radius: 1rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dropdown-item {
    display: flex;
    cursor: pointer;
    align-items: center;
    gap: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    --tw-text-opacity: 1;
    color: rgb(51 65 85 / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.dropdown-item:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}

/* ─── Modal ──────────────────────────────────────────── */
.modal-overlay {
    position: fixed;
    inset: 0px;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(0 0 0 / 0.4);
    padding: 1rem;
    --tw-backdrop-blur: blur(4px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.modal-content {
    max-height: 90vh;
    width: 100%;
    max-width: 32rem;
    overflow-y: auto;
    border-radius: 1.25rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

/* ─── Badge ──────────────────────────────────────────── */
.badge {
    display: inline-flex;
    align-items: center;
    border-radius: 9999px;
    padding-left: 0.625rem;
    padding-right: 0.625rem;
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 600;
}

/* ─── Chart container ────────────────────────────────── */
.chart-container {
    border-radius: 1rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1.5rem;
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

/* ─── Notification badge ─────────────────────────────── */
.notification-badge {
    position: absolute;
    top: -0.25rem;
    right: -0.25rem;
    display: flex;
    height: 1rem;
    width: 1rem;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
    font-size: 9px;
    font-weight: 700;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

/* ─── Metric card gradient variants ─────────────────── */
.metric-purple {
    background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);
    border-color: #e9d5ff;
}
.metric-green {
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
    border-color: #bbf7d0;
}
.metric-amber {
    background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
    border-color: #fde68a;
}
.metric-rose {
    background: linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%);
    border-color: #fecdd3;
}

/* ─── Sidebar section label ──────────────────────────── */
.sidebar-section-label {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 1.25rem;
    padding-bottom: 0.375rem;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: rgb(255 255 255 / 0.3);
}

/* ─── Page transition wrapper ────────────────────────── */
.page-enter {
    animation: fadeUp 0.3s ease-out both;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;IACI,iBAAiB;AACrB;;AAEA,2DAA2D;AAC3D;IACI,wFAAwF;IACxF,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY,EAAE,aAAa;IAC3B,kBAAkB;IAClB,8EAA8E;IAC9E,WAAW,EAAE,YAAY;IACzB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY,EAAE,aAAa;IAC3B,kBAAkB;IAClB,8EAA8E;IAC9E,cAAc,EAAE,aAAa;IAC7B,oBAAoB;AACxB;;AAEA,2DAA2D;AAEvD;IAAA,wBACyD;IADzD,sBACyD;IADzD,4DACyD;IADzD,wCACyD;IADzD,oBACyD;IADzD,uBACyD;IADzD,kBACyD;IADzD,mBACyD;IADzD,gBACyD;IADzD,kBACyD;IADzD,iBACyD;IADzD,gBACyD;IADzD,yBACyD;IADzD,qBACyD;IADzD,oBACyD;IADzD;AACyD;AAGzD;IAAA,wBAAkE;IAAlE,sBAAkE;IAAlE,4DAAkE;IAAlE,qBAAkE;IAAlE,wBAAkE;IAAlE,kBAAkE;IAAlE,mBAAkE;IAAlE,mBAAkE;IAAlE,oBAAkE;IAAlE,oBAAkE;IAAlE;AAAkE;AAGlE;IAAA,+FAA2D;IAA3D,wDAA2D;IAA3D,0BAA2D;IAA3D;AAA2D;AAA3D;IAAA;AAA2D;;AAG/D,2DAA2D;AAEvD;IAAA,uBAAwD;IAAxD,cAAwD;IAAxD,mBAAwD;IAAxD,oBAAwD;IAAxD,gBAAwD;IAAxD,oBAAwD;IAAxD;AAAwD;AAGxD;IAAA,WAGiC;IAHjC,sBAGiC;IAHjC,iBAGiC;IAHjC,sBAGiC;IAHjC,4DAGiC;IAHjC,kBAGiC;IAHjC,4DAGiC;IAHjC,sBAGiC;IAHjC,uBAGiC;IAHjC,qBAGiC;IAHjC,wBAGiC;IAHjC,mBAGiC;IAHjC,oBAGiC;IAHjC,8BAGiC;IAHjC,mBAGiC;IAHjC,wBAGiC;IAHjC,wDAGiC;IAHjC,0BAGiC;IAHjC;AAGiC;AAHjC;IAAA,oBAGiC;IAHjC;AAGiC;AAHjC;IAAA,sBAGiC;IAHjC,4DAGiC;IAHjC,2GAGiC;IAHjC,yGAGiC;IAHjC,4FAGiC;IAHjC,oBAGiC;IAHjC;AAGiC;AAGjC;IAAA,WAEwD;IAFxD,sBAEwD;IAFxD,iBAEwD;IAFxD,sBAEwD;IAFxD,4DAEwD;IAFxD,kBAEwD;IAFxD,4DAEwD;IAFxD,sBAEwD;IAFxD,uBAEwD;IAFxD,qBAEwD;IAFxD,wBAEwD;IAFxD,mBAEwD;IAFxD,oBAEwD;IAFxD,8BAEwD;IAFxD,mBAEwD;IAFxD,wBAEwD;IAFxD,wDAEwD;IAFxD,0BAEwD;IAFxD;AAEwD;AAFxD;IAAA,sBAEwD;IAFxD,4DAEwD;IAFxD,2GAEwD;IAFxD,yGAEwD;IAFxD,4FAEwD;IAFxD,oBAEwD;IAFxD;AAEwD;AAE5D;IACI,qBAAqB;AACzB;;AAEA,2DAA2D;AAEvD;IAAA,sBAEgC;IAFhC,kBAEgC;IAFhC,mBAEgC;IAFhC,qBAEgC;IAFhC,wBAEgC;IAFhC,mBAEgC;IAFhC,oBAEgC;IAFhC,gBAEgC;IAFhC,oBAEgC;IAFhC,mDAEgC;IAFhC,0CAEgC;IAFhC,uDAEgC;IAFhC,uGAEgC;IAFhC,wBAEgC;IAFhC,wDAEgC;IAFhC,0BAEgC;IAFhC;AAEgC;AAFhC;IAAA,6EAEgC;IAFhC,iGAEgC;IAFhC;AAEgC;AAFhC;IAAA,iBAEgC;IAFhC,iBAEgC;IAFhC;AAEgC;AAHpC;IAII,6DAA6D;AACjE;AACA;IACI,6DAA6D;IAC7D,2BAA2B;AAC/B;AAEI;IAAA,sBAEkC;IAFlC,iBAEkC;IAFlC,sBAEkC;IAFlC,4DAEkC;IAFlC,kBAEkC;IAFlC,4DAEkC;IAFlC,kBAEkC;IAFlC,mBAEkC;IAFlC,qBAEkC;IAFlC,wBAEkC;IAFlC,mBAEkC;IAFlC,oBAEkC;IAFlC,gBAEkC;IAFlC,oBAEkC;IAFlC,kDAEkC;IAFlC,wBAEkC;IAFlC,wDAEkC;IAFlC,0BAEkC;IAFlC;AAEkC;AAFlC;IAAA,kBAEkC;IAFlC;AAEkC;AAGlC;IAAA,sBAEkC;IAFlC,iBAEkC;IAFlC,sBAEkC;IAFlC,4DAEkC;IAFlC,kBAEkC;IAFlC,mBAEkC;IAFlC,qBAEkC;IAFlC,wBAEkC;IAFlC,mBAEkC;IAFlC,oBAEkC;IAFlC,gBAEkC;IAFlC,oBAEkC;IAFlC,gDAEkC;IAFlC,wBAEkC;IAFlC,wDAEkC;IAFlC,0BAEkC;IAFlC;AAEkC;AAFlC;IAAA,sBAEkC;IAFlC,4DAEkC;IAFlC,kBAEkC;IAFlC;AAEkC;AAGlC;IAAA,sBAGgC;IAHhC,kBAGgC;IAHhC,0DAGgC;IAHhC,kBAGgC;IAHhC,mBAGgC;IAHhC,qBAGgC;IAHhC,wBAGgC;IAHhC,mBAGgC;IAHhC,oBAGgC;IAHhC,gBAGgC;IAHhC,oBAGgC;IAHhC,mDAGgC;IAHhC,0CAGgC;IAHhC,uDAGgC;IAHhC,uGAGgC;IAHhC,wBAGgC;IAHhC,wDAGgC;IAHhC,0BAGgC;IAHhC;AAGgC;AAHhC;IAAA,kBAGgC;IAHhC,0DAGgC;IAHhC,6EAGgC;IAHhC,iGAGgC;IAHhC;AAGgC;AAHhC;IAAA,iBAGgC;IAHhC,iBAGgC;IAHhC;AAGgC;;AAGpC,2DAA2D;AAEvD;IAAA,mBAA8E;IAA9E,aAA8E;IAA9E,sBAA8E;IAA9E;AAA8E;AAA9E;IAAA;QAAA,mBAA8E;QAA9E,mBAA8E;QAA9E;IAA8E;AAAA;AAG9E;IAAA,gCAAiE;IAAjE,iBAAiE;IAAjE,iBAAiE;IAAjE,gBAAiE;IAAjE,oBAAiE;IAAjE;AAAiE;AAAjE;IAAA;QAAA,mBAAiE;QAAjE;IAAiE;AAAA;;AAGrE,2DAA2D;AAEvD;IAAA,aAAqE;IAArE,sBAAqE;IAArE,mBAAqE;IAArE,uBAAqE;IAArE,iBAAqE;IAArE,oBAAqE;IAArE,oBAAqE;IAArE;AAAqE;;AAGzE,2DAA2D;AAEvD;IAAA,WAE0D;IAF1D,sBAE0D;IAF1D,iBAE0D;IAF1D,sBAE0D;IAF1D,4DAE0D;IAF1D,kBAE0D;IAF1D,4DAE0D;IAF1D,qBAE0D;IAF1D,wBAE0D;IAF1D,oBAE0D;IAF1D,mBAE0D;IAF1D,mBAE0D;IAF1D,oBAE0D;IAF1D,8BAE0D;IAF1D,mBAE0D;IAF1D,wBAE0D;IAF1D,wDAE0D;IAF1D;AAE0D;AAF1D;IAAA,sBAE0D;IAF1D,4DAE0D;IAF1D,2GAE0D;IAF1D,yGAE0D;IAF1D,4FAE0D;IAF1D,oBAE0D;IAF1D;AAE0D;AAF1D;IAAA;QAAA;IAE0D;AAAA;AAE9D;IACI,qBAAqB;AACzB;;AAEA,2DAA2D;AAEvD;IAAA,gBAA6E;IAA7E,mBAA6E;IAA7E,iBAA6E;IAA7E,sBAA6E;IAA7E,4DAA6E;IAA7E,kBAA6E;IAA7E,4DAA6E;IAA7E,qBAA6E;IAA7E,wBAA6E;IAA7E,gFAA6E;IAA7E,oGAA6E;IAA7E;AAA6E;AAG7E;IAAA,aAC+D;IAD/D,eAC+D;IAD/D,mBAC+D;IAD/D,WAC+D;IAD/D,kBAC+D;IAD/D,mBAC+D;IAD/D,qBAC+D;IAD/D,wBAC+D;IAD/D,mBAC+D;IAD/D,oBAC+D;IAD/D,oBAC+D;IAD/D,gDAC+D;IAD/D,+FAC+D;IAD/D,wDAC+D;IAD/D;AAC+D;AAD/D;IAAA,kBAC+D;IAD/D,4DAC+D;IAD/D,oBAC+D;IAD/D;AAC+D;;AAGnE,2DAA2D;AAEvD;IAAA,eAC2C;IAD3C,UAC2C;IAD3C,WAC2C;IAD3C,aAC2C;IAD3C,mBAC2C;IAD3C,uBAC2C;IAD3C,kCAC2C;IAD3C,aAC2C;IAD3C,6BAC2C;IAD3C;AAC2C;AAG3C;IAAA,gBAAmF;IAAnF,WAAmF;IAAnF,gBAAmF;IAAnF,gBAAmF;IAAnF,sBAAmF;IAAnF,kBAAmF;IAAnF,4DAAmF;IAAnF,gDAAmF;IAAnF,6DAAmF;IAAnF;AAAmF;;AAGvF,2DAA2D;AAEvD;IAAA,oBAAgF;IAAhF,mBAAgF;IAAhF,qBAAgF;IAAhF,sBAAgF;IAAhF,uBAAgF;IAAhF,qBAAgF;IAAhF,wBAAgF;IAAhF,kBAAgF;IAAhF,iBAAgF;IAAhF;AAAgF;;AAGpF,2DAA2D;AAEvD;IAAA,mBAAiE;IAAjE,iBAAiE;IAAjE,sBAAiE;IAAjE,4DAAiE;IAAjE,kBAAiE;IAAjE,4DAAiE;IAAjE,eAAiE;IAAjE,0CAAiE;IAAjE,uDAAiE;IAAjE;AAAiE;;AAGrE,2DAA2D;AAEvD;IAAA,kBAE0B;IAF1B,aAE0B;IAF1B,eAE0B;IAF1B,aAE0B;IAF1B,YAE0B;IAF1B,WAE0B;IAF1B,mBAE0B;IAF1B,uBAE0B;IAF1B,qBAE0B;IAF1B,iBAE0B;IAF1B,sBAE0B;IAF1B,4DAE0B;IAF1B,kBAE0B;IAF1B,0DAE0B;IAF1B,cAE0B;IAF1B,gBAE0B;IAF1B,oBAE0B;IAF1B;AAE0B;;AAG9B,0DAA0D;AAC1D;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;AACA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;AACA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;AACA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA,2DAA2D;AAEvD;IAAA,oBAAqF;IAArF,qBAAqF;IAArF,oBAAqF;IAArF,wBAAqF;IAArF,kBAAqF;IAArF,iBAAqF;IAArF,gBAAqF;IAArF,yBAAqF;IAArF,qBAAqF;IAArF;AAAqF;;AAGzF,2DAA2D;AAC3D;IACI,oCAAoC;AACxC","sourcesContent":["/* ─── Global ─────────────────────────────────────────── */\n.App {\n    min-height: 100vh;\n}\n\n/* ─── Login page background ──────────────────────────── */\n.login-bg {\n    background: radial-gradient(ellipse at top left,  #2e1065 0%, #1e1b4b 40%, #0f0a28 100%);\n    position: relative;\n    overflow: hidden;\n}\n.login-bg::before {\n    content: '';\n    position: absolute;\n    width: 600px; height: 600px;\n    border-radius: 50%;\n    background: radial-gradient(circle, rgba(139,92,246,0.15) 0%, transparent 70%);\n    top: -200px; left: -200px;\n    pointer-events: none;\n}\n.login-bg::after {\n    content: '';\n    position: absolute;\n    width: 400px; height: 400px;\n    border-radius: 50%;\n    background: radial-gradient(circle, rgba(109,40,217,0.12) 0%, transparent 70%);\n    bottom: -100px; right: -100px;\n    pointer-events: none;\n}\n\n/* ─── Data table ─────────────────────────────────────── */\n.data-table th {\n    @apply text-left font-semibold text-slate-500 text-xs uppercase tracking-widest\n           py-3 px-4 bg-slate-50/80 border-b border-slate-100;\n}\n.data-table td {\n    @apply py-3.5 px-4 text-slate-700 border-b border-slate-50 text-sm;\n}\n.data-table tbody tr {\n    @apply transition-colors duration-150 hover:bg-purple-50/40;\n}\n\n/* ─── Form elements ──────────────────────────────────── */\n.form-label {\n    @apply block text-sm font-semibold text-slate-700 mb-1.5;\n}\n.form-input {\n    @apply w-full px-3.5 py-2.5 border border-slate-200 rounded-xl text-sm\n           focus:ring-2 focus:ring-purple-400 focus:border-purple-400\n           bg-white transition-all duration-200 outline-none\n           placeholder:text-slate-400;\n}\n.form-select {\n    @apply w-full px-3.5 py-2.5 border border-slate-200 rounded-xl text-sm\n           focus:ring-2 focus:ring-purple-400 focus:border-purple-400\n           bg-white transition-all duration-200 outline-none;\n}\n.form-input:hover, .form-select:hover {\n    border-color: #c4b5fd;\n}\n\n/* ─── Buttons ────────────────────────────────────────── */\n.btn-primary {\n    @apply px-4 py-2.5 rounded-xl font-semibold text-sm text-white\n           transition-all duration-200 active:scale-95\n           shadow-sm hover:shadow-md;\n    background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);\n}\n.btn-primary:hover {\n    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n    transform: translateY(-1px);\n}\n.btn-secondary {\n    @apply bg-purple-50 hover:bg-purple-100 text-purple-800 border border-purple-200\n           px-4 py-2.5 rounded-xl font-semibold text-sm\n           transition-all duration-200;\n}\n.btn-outline {\n    @apply border border-slate-200 hover:border-slate-300 hover:bg-slate-50\n           text-slate-700 px-4 py-2.5 rounded-xl font-semibold text-sm\n           transition-all duration-200;\n}\n.btn-danger {\n    @apply bg-rose-600 hover:bg-rose-700 text-white\n           px-4 py-2.5 rounded-xl font-semibold text-sm\n           transition-all duration-200 active:scale-95\n           shadow-sm hover:shadow-md;\n}\n\n/* ─── Page layout ────────────────────────────────────── */\n.page-header {\n    @apply flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8;\n}\n.page-title {\n    @apply text-2xl md:text-3xl font-bold text-slate-900 font-heading;\n}\n\n/* ─── Empty state ────────────────────────────────────── */\n.empty-state {\n    @apply flex flex-col items-center justify-center py-20 text-slate-400;\n}\n\n/* ─── Search input ───────────────────────────────────── */\n.search-input {\n    @apply pl-10 pr-4 py-2.5 border border-slate-200 rounded-xl text-sm\n           focus:ring-2 focus:ring-purple-400 focus:border-purple-400\n           w-full md:w-72 outline-none bg-white transition-all;\n}\n.search-input:hover {\n    border-color: #c4b5fd;\n}\n\n/* ─── Dropdown ───────────────────────────────────────── */\n.dropdown-content {\n    @apply bg-white rounded-2xl shadow-xl border border-slate-100 py-1.5 min-w-40;\n}\n.dropdown-item {\n    @apply px-4 py-2.5 text-sm text-slate-700 hover:bg-purple-50 hover:text-purple-900\n           cursor-pointer flex items-center gap-2 transition-colors;\n}\n\n/* ─── Modal ──────────────────────────────────────────── */\n.modal-overlay {\n    @apply fixed inset-0 bg-black/40 backdrop-blur-sm z-50\n           flex items-center justify-center p-4;\n}\n.modal-content {\n    @apply bg-white rounded-3xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto;\n}\n\n/* ─── Badge ──────────────────────────────────────────── */\n.badge {\n    @apply inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold;\n}\n\n/* ─── Chart container ────────────────────────────────── */\n.chart-container {\n    @apply bg-white rounded-2xl border border-slate-100 p-6 shadow-sm;\n}\n\n/* ─── Notification badge ─────────────────────────────── */\n.notification-badge {\n    @apply absolute -top-1 -right-1 w-4 h-4 bg-rose-500 text-white\n           text-[9px] font-bold rounded-full flex items-center justify-center\n           border border-white;\n}\n\n/* ─── Metric card gradient variants ─────────────────── */\n.metric-purple {\n    background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);\n    border-color: #e9d5ff;\n}\n.metric-green {\n    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);\n    border-color: #bbf7d0;\n}\n.metric-amber {\n    background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);\n    border-color: #fde68a;\n}\n.metric-rose {\n    background: linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%);\n    border-color: #fecdd3;\n}\n\n/* ─── Sidebar section label ──────────────────────────── */\n.sidebar-section-label {\n    @apply px-6 pt-5 pb-1.5 text-xs font-semibold uppercase tracking-widest text-white/30;\n}\n\n/* ─── Page transition wrapper ────────────────────────── */\n.page-enter {\n    animation: fadeUp 0.3s ease-out both;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
